import React from "react";
import TreandingBlogPost from "./TreandingBlogPost";

function CategoryCard({ data, activeCategory, setCategoryId, navigate }) {
   return navigate ? (
      <a href={`/company/blogs/category/${data?._id}`}>
         <div className={"blogCategory__button"}>
            <img src={`${process.env.REACT_APP_FILE_URL}/${data?.logo}`} alt="" className="logo" />
            <p className="text">{data?.title}</p>
         </div>
      </a>
   ) : (
      <div
         className={`blogCategory__button ${
            activeCategory?._id && data?._id === activeCategory?._id && "active"
         }`}
         onClick={() => {
            window.history.pushState(null, "", `/company/blogs/category/${data?._id}`);
            setCategoryId && setCategoryId(data?._id);
         }}
      >
         <img src={`${process.env.REACT_APP_FILE_URL}/${data?.logo}`} alt="" className="logo" />
         <p className="text">{data?.title}</p>
      </div>
   );
}

export default function SideBar({
   otherCategory,
   featuredBlogs,
   currentCategory,
   setCategoryId,
   navigate,
}) {
   return (
      <div className="blogCategory__content__wrapper__sidebar">
         <div className="blogCategory__content__wrapper__sidebar__category">
            <h3 className="blogtopic__heading">Topics</h3>
            <div className="blogCategory__content__wrapper__sidebar__category__container">
               {otherCategory &&
                  Object.entries(otherCategory)?.map(([key, value]) => {
                     return (
                        <CategoryCard
                           data={value}
                           activeCategory={currentCategory}
                           setCategoryId={setCategoryId}
                           navigate={navigate}
                        />
                     );
                  })}
            </div>
         </div>
         <div className="blogCategory__content__wrapper__sidebar__featured">
            <h3 className="blogtopic__heading">Featured Blogs</h3>
            <div className="blogCategory__content__wrapper__sidebar__featured__blog__wrapper">
               {featuredBlogs &&
                  Object.entries(featuredBlogs)?.map(([key, value]) => {
                     return <TreandingBlogPost data={value} />;
                  })}
            </div>
         </div>
      </div>
   );
}
